module.exports = __webpack_public_path__ + "img/template_lost_pet_poster.50fe8e99.jpg";